import { render, staticRenderFns } from "./CranesListTable.vue?vue&type=template&id=01875770&"
import script from "./CranesListTable.vue?vue&type=script&lang=ts&"
export * from "./CranesListTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports